import StackTrace from 'stacktrace-js';

function formatStacktraceOutput(errorName, errorMessage, stackframes) {
  const stackWithSourcemapsTranslation = stackframes
    .map(
      ({ functionName, fileName, lineNumber, columnNumber }) =>
        `at ${functionName} (${fileName}:${lineNumber}:${columnNumber})`
    )
    .join('\n');

  return `${errorName}: ${errorMessage}\n${stackWithSourcemapsTranslation}`;
}

function extractAppNameFromRawStacktrace(stacktrace) {
  const [microAppNameMatch] = stacktrace.match(/\w?[-\w]*-app\.min\.js/);

  if (microAppNameMatch) {
    return microAppNameMatch.replace('-app.min.js', '');
  }

  return null;
}

function decodeMinifiedStacktrace(error) {
  return StackTrace.fromError(error).then((stackframes) => {
    const appName = extractAppNameFromRawStacktrace(error.stack);

    error.message = `[${appName}-app] ${error.message}`;

    error.appName = appName;

    error.stack = formatStacktraceOutput(
      error.name,
      error.message,
      stackframes
    );

    return error;
  });
}

export default decodeMinifiedStacktrace;
